import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import AppRoutes from "../../common/routes";
import { useSelector } from "react-redux";

const baseMenuItems = [
  {
    path: AppRoutes.restaurant_dashboard,
    label: "Dashboard",
    icon: "grid",
  },
  {
    path: AppRoutes.restaurant_menu,
    label: "My Item",
    icon: "people",
  },
  {
    path: AppRoutes.restaurant_profile,
    label: "My Profile",
    icon: "person",
  },
  {
    path: AppRoutes.restaurant_settings,
    label: "Tools",
    icon: "settings",
  },
];

const FooterDisplay = (props) => {
  const [currPage, setCurrPage] = useState("");
  const [menuItems, setMenuItems] = useState(baseMenuItems);
  const userData = useSelector((state) => state.userProfile.dataFetched);

  useEffect(() => {
    let currLocation = window.location.pathname;
    setCurrPage(currLocation);
  }, [window.location.href]);

  useEffect(() => {
    if (userData && userData.isRestaurantOwner) {
      setMenuItems((prevItems) => {
        const hasDeliveryItem = prevItems.some(
          (item) => item.path === AppRoutes.restaurant_delivery
        );
        if (!hasDeliveryItem) {
          const newItems = [...prevItems];
          newItems.splice(1, 0, {
            path: AppRoutes.restaurant_delivery,
            label: "My Delivery",
            icon: "bicycle",
          });
          return newItems;
        }
        return prevItems;
      });
    } else {
      setMenuItems(baseMenuItems);
    }
  }, [userData]);

  return (
    <div className={`footer-cover ${props.short ? "short" : ""}`}>
      <div className="footer">
        <div className="footer-display">
          <div>
            <ul>
              {menuItems.map((item, index) => (
                <li key={index}>
                  <NavLink
                    className={({ isActive }) => (isActive ? "active" : "")}
                    to={item.path}
                  >
                    <div className="icon-cover">
                      {currPage === item.path ? (
                        <div>
                          <ion-icon name={item.icon}></ion-icon>
                        </div>
                      ) : (
                        <div>
                          <ion-icon name={`${item.icon}-outline`}></ion-icon>
                        </div>
                      )}
                    </div>
                    <div>
                      <h3>{item.label}</h3>
                    </div>
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FooterDisplay;
